import React from "react";
import { FieldArray, useFormikContext } from "formik";
import Illustration from "../../../../../partials/content/Illustration";
import { Table } from "react-bootstrap";
import BootstrapTooltip from "../../../../../partials/content/BootstrapTooltip";
import {
  FormArrayTextField,
  FormOutlinedNoMarginTextField,
} from "../../../../../partials/content/Forms/FormField";
import { InputAdornment } from "@material-ui/core";

function DiscountFreeItems({
  setArrayName,
  setIndexSelected,
  setOpenSearchItemType,
  setOpenSearchItem,
  setItemSelected,
  setOpenSearchUom,
  displayOnly = false,
}) {
  const { values, setFieldValue } = useFormikContext();
  return (
    <div className="row">
      <div className="col-sm-12 col-md-12 col-lg-12">
        <FieldArray name="discountFreeItem">
          {({ push, remove }) => (
            <React.Fragment>
              <div className="row">
                <div className="col-sm-12 col-md-12 col-lg-12">
                  <div className="card">
                    <Table borderless size="sm" responsive="xl">
                      {values.discountFreeItem &&
                      values.discountFreeItem.length > 0 ? (
                        <thead className="text-center">
                          <tr>
                            <th style={{ width: "55%" }}>Item Name</th>
                            <th style={{ width: "20%" }}>Quantity</th>
                            <th style={{ width: "20%" }}>Unit</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                      ) : null}
                      <tbody>
                        {values.discountFreeItem &&
                        values.discountFreeItem.length > 0 ? (
                          values.discountFreeItem.map((item, index) => {
                            return (
                              <React.Fragment key={index}>
                                <tr>
                                  <td>
                                    <FormOutlinedNoMarginTextField
                                      value={`${item.itemCode} ${item.itemName}`}
                                      InputProps={{
                                        startAdornment:
                                          item.itemType > 0 ? (
                                            <InputAdornment position="start">
                                              <BootstrapTooltip
                                                title={item.itemTypeName}
                                              >
                                                <i
                                                  className={
                                                    item.itemType === 1
                                                      ? "fas fa-boxes text-success"
                                                      : item.itemType === 2
                                                      ? "fas fa-tools text-primary"
                                                      : item.itemType === 3
                                                      ? "fas fa-building text-info"
                                                      : item.itemType === 4
                                                      ? "fas fa-boxes text-warning"
                                                      : item.itemType === 5
                                                      ? "fas fa-boxes text-danger"
                                                      : null
                                                  }
                                                ></i>
                                              </BootstrapTooltip>
                                            </InputAdornment>
                                          ) : null,
                                        readOnly: true,
                                      }}
                                    />
                                  </td>
                                  <td>
                                    <FormArrayTextField
                                      index={index}
                                      arrayPropName="discountFreeItem"
                                      propName="qty"
                                      quantityField
                                      margin="none"
                                    />
                                  </td>
                                  <td>
                                    <FormArrayTextField
                                      index={index}
                                      arrayPropName="discountFreeItem"
                                      propName="uomName"
                                      margin="none"
                                      searchButton
                                      readonly
                                      onSearchClick={() => {
                                        setArrayName("discountFreeItem");
                                        setIndexSelected(index);
                                        setItemSelected(item);
                                        setOpenSearchUom(true);
                                      }}
                                    />
                                  </td>
                                  <td
                                    style={{
                                      whiteSpace: "nowrap",
                                    }}
                                    className="text-center"
                                  >
                                    {!displayOnly ? (
                                      <BootstrapTooltip
                                        title={
                                          item.deleteInd
                                            ? "Undo Delete"
                                            : "Delete Discount Free Item"
                                        }
                                      >
                                        <button
                                          type="button"
                                          className={`btn btn-icon btn-label-${
                                            item.deleteInd
                                              ? "warning"
                                              : "danger"
                                          } btn-md btn-circle mx-1`}
                                          onClick={() => {
                                            if (item.ID > 0) {
                                              setFieldValue(
                                                "discountFreeItem[" +
                                                  index +
                                                  "].deleteInd",
                                                !item.deleteInd
                                              );
                                            } else {
                                              remove(index);
                                            }
                                          }}
                                        >
                                          {item.deleteInd ? (
                                            <i className="fas fa-undo-alt"></i>
                                          ) : (
                                            <i className="fas fa-trash-alt"></i>
                                          )}
                                        </button>
                                      </BootstrapTooltip>
                                    ) : null}
                                  </td>
                                </tr>
                              </React.Fragment>
                            );
                          })
                        ) : (
                          <tr>
                            <td className="text-center py-3" colSpan="4">
                              <Illustration
                                imageSource="INVIFO Sales.png"
                                guidance="You don't have any Discount Free items yet"
                                guidanceLeftIcon="fas fa-info-circle kt-font-warning"
                                size="sm"
                              ></Illustration>
                            </td>
                          </tr>
                        )}
                        <tr>
                          <td className="text-center py-3" colSpan="4">
                            <button
                              type="button"
                              className="btn btn-label-primary btn-md btn-pill btn-bold mx-1"
                              onClick={() => {
                                setArrayName("discountFreeItem");
                                setIndexSelected(0);
                                setOpenSearchItemType(true);
                              }}
                            >
                              <i className="fas fa-plus-circle"></i>
                              Add Free Item
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </div>
                </div>
              </div>
            </React.Fragment>
          )}
        </FieldArray>
      </div>
    </div>
  );
}

export default DiscountFreeItems;
